import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const AccountDefaultIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="M8 0c2.217 0 4 1.964 4 4.287 0 1.17-.493 2.4-1.205 3.333-.702.92-1.706 1.666-2.795 1.666S5.907 8.54 5.205 7.62C4.493 6.687 4 5.458 4 4.287 4 1.964 5.782 0 8 0Zm0 1C6.404 1 5 2.444 5 4.287c0 .91.394 1.932 1 2.727.617.809 1.363 1.272 2 1.272s1.383-.463 2-1.272c.606-.795 1-1.816 1-2.727C11 2.444 9.596 1 8 1Z M4.527 9a.5.5 0 0 1 .036.996l-.12.002a5.33 5.33 0 0 0-1.784.257c-1 .335-1.587.942-1.653 1.945L1 12.393V15.5a.5.5 0 0 1-.992.09L0 15.5v-3.107c0-1.6.904-2.605 2.341-3.086a6.247 6.247 0 0 1 1.893-.31L4.527 9ZM13.659 9.307A6.28 6.28 0 0 0 11.529 9h-.03l-.115.015a.5.5 0 0 0 .143.985l.256-.002c.47.008 1.027.08 1.558.258 1.063.356 1.659 1.018 1.659 2.138V15.5l.008.09A.5.5 0 0 0 16 15.5v-3.107l-.006-.215c-.077-1.475-.964-2.412-2.335-2.87Z" />
  </IconWrapper>
)

export default AccountDefaultIconSmall
